import React, { useState, useEffect } from "react";

import "../css/Page__Styles.css";
import "../css/Page__Contact.css";

import Footer from "../components/Footer.jsx";
import PrivacyModal from "../components/PrivacyModal.jsx";

import contactImage from "../img/portrait-eme.png";


export const Contact = () => {

  const [submitted, setSubmitted] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);

  useEffect(() => {
        document.title = "Eme / Contacto";
      }, []);


  const handleSubmit = async (event) => {
  event.preventDefault();

  const form = event.currentTarget;
  const formData = new FormData(form);

    try {
      const response = await fetch("/contact.php", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        setSubmitted(true);
        form.reset();
      } else {
        alert(data.message || "No se ha podido enviar el mensaje.");
      }

    } catch (error) {
      console.error("Error al enviar el formulario:", error);

      alert("Ha ocurrido un error. Inténtalo de nuevo.");
    }
  };


  return (

    <div>

      <div className="page_contact">

        <div className="block-left">

          <h2>
            ¿Y si este fuera el momento de decidir? Si quieres hablarlo antes, estoy a un mensaje de distancia.
          </h2>


          <form
            className="contact_form"
            onSubmit={handleSubmit}
          >

            <div className="form_field">

              <input
                type="text"
                id="name"
                name="name"
                placeholder=" "
                required
              />

              <label htmlFor="name">
                Nombre y apellidos
              </label>

            </div>


            <div className="form_field">

              <input
                type="email"
                id="email"
                name="email"
                placeholder=" "
                required
              />

              <label htmlFor="email">
                Email
              </label>

            </div>


            <div className="form_field">

              <input
                type="text"
                id="subject"
                name="subject"
                placeholder=" "
                required
              />

              <label htmlFor="subject">
                Asunto
              </label>

            </div>


            <div className="form_field">

              <textarea
                id="message"
                name="message"
                placeholder=" "
                rows="6"
                required
              />

              <label htmlFor="message">
                Mensaje
              </label>

            </div>


            <div className="form_checkbox">

              <input
                type="checkbox"
                id="privacy"
                name="privacy"
                required
              />

              <label htmlFor="privacy">

                Acepto la{" "}

                <button
                  type="button"
                  className="privacy_link"
                  onClick={() => setPrivacyOpen(true)}
                >
                  política de privacidad
                </button>

              </label>

            </div>


            <button 
              type="submit"
              className="button_send"
            >
              Enviar
            </button>


            {submitted && (

              <p className="form_success">
                Mensaje enviado
              </p>

            )}

          </form>

        </div>


        <div className="block-right">

          <img
            src={contactImage}
            alt=""
          />

        </div>

      </div>


      <Footer />


      <PrivacyModal
        isOpen={privacyOpen}
        onClose={() => setPrivacyOpen(false)}
      />

    </div>

  );
};


export default Contact;